<template>
  <div class="tabs">
    <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-left: 20px;">
      <el-tab-pane label="Quest一体机游戏分类" name="first">
        <ul class="infinite-list" v-infinite-scroll="load" :infinite-scroll-delay="400" :infinite-scroll-immediate="false" style="overflow:auto;height: 670px;">
             <Goodslist style="margin-left: -20px; height: 680px;" :goods="iteminfo[0]['quest']"></Goodslist>
        </ul>
      </el-tab-pane>
      <el-tab-pane label=" Steam VR 电脑游戏分类" name="second">
        <ul class="infinite-list" v-infinite-scroll="load" :infinite-scroll-delay="400" style="overflow:auto;height: 670px;">
             <Goodslist style="margin-left: -20px; height: 680px;" :goods="iteminfo[0]['pc']"></Goodslist>
        </ul>
      </el-tab-pane>
      <el-tab-pane label=" Oculus Quest 教程工具" name="third">
        <ul class="infinite-list" v-infinite-scroll="load" :infinite-scroll-delay="400" style="overflow:auto;height: 670px;">
             <Goodslist style="margin-left: -20px; height: 680px;" :goods="iteminfo[0]['oculusset']"></Goodslist>
        </ul>
      </el-tab-pane>
      <el-tab-pane label="搜索结果" name="soso">
        <ul class="infinite-list" v-infinite-scroll="load" :infinite-scroll-delay="400" style="overflow:auto;height: 670px;">
             <Goodslist style="margin-left: -20px; height: 680px;" :goods="iteminfo[0]['soso']"></Goodslist>
        </ul>
      </el-tab-pane>
      <el-tab-pane label=" 开通VIP会员" name="fourth">
        <vip></vip>
      </el-tab-pane>
      <el-tab-pane label="公告资讯" name="fourth2"> <h2 style="height: 500px;color: blue;">欢迎进入本站官方群：414755844</h2></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Goodslist from 'components/goods/Goodslist'

import vip from './vip'

export default {
  components:{
    Goodslist,
    vip
  },
  props:{
    iteminfo:{
      type:Array,
      default(){
        return []
      }
    }
  },
  data () {
    return {
      activeName: 'first',
      getinfo:{
        name:'',
        pagename:'quest',
        index:0
      },
    }
  },
  methods:{
    handleClick(tab) {
      if(this.getinfo['index'] == tab.index){
        this.$notify({
          title: '警告',
          message: '重复点击',
          type: 'warning'
        });
      }else{
        this.getinfo['index'] = tab.index
        switch(tab.index){
          case '0':
            this.getinfo['pagename'] = 'quest'
            this.$emit('isbar')

            break;
          case '1' :
            this.getinfo['pagename'] = 'pc'
            this.$emit('isbar')

            break;
          case '2' :
            this.getinfo['pagename'] = 'oculusset'
            this.$emit('isbar',this.getinfo)
            break
        }
      }

    },
    load(){
      this.$emit('ispage',this.getinfo)
    }
  },
}
</script>

<style scoped>

</style>
